// @ts-nocheck
import { Handler } from "@insite/client-framework/HandlerCreator";
import {
    CallApi,
    chain,
} from "@insite/client-framework/Store/Components/ProductRecommendations/Handlers/SendImpressionTracking";
import { peeriusSiteName } from "@insite/client-framework/Store/Components/ProductRecommendations/ProductRecommendationsSelector";
import { sendImpressionTracking as sendImpressionTrackingApi } from "@store/Framework/Services/StoreProductRecommendationsService";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<{ recommendationIds: number[] }>;

export const StoreCallApi: HandlerType = ({ getState, parameter: { recommendationIds } }) => {
    sendImpressionTrackingApi(peeriusSiteName(getState()), recommendationIds);
};
replaceInChain(chain, CallApi, StoreCallApi);
